import $ from 'jquery';
import header from './header';
import LoadContents from '@/js/plugins/LoadContents';

const setAccordionAction = () => {
    document.querySelectorAll('.js-accordion').forEach((accordion) => {
        accordion.querySelector('.js-accordion-summary').addEventListener('click', (e) => {
            e.preventDefault();
            const isShow = accordion.hasAttribute('data-open');
            if (isShow) {
                delete accordion.dataset.open;
            } else {
                accordion.dataset.open = '';
            }
        });
    });
}

const main = () => {
    header();
    new LoadContents();
    setAccordionAction();
}

export default main;
